import React, { useState } from 'react';
import { Link } from '@chakra-ui/react';
import { numberFormat } from 'utils/mathCommon';
import {
  Box,
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverCloseButton,
} from '@chakra-ui/react';
import PACKAGE_DATA from '__mocks__/PackageData';
import dayjs from 'dayjs';
import { findPackageByAmount, parseBalance, bnum } from 'utils/helper';
import { formatDateYYYYMMDDHHMM } from 'utils/dateFormat';
import { notification } from 'utils/notification';
import * as AppConstants from 'Constants';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Button, Tooltip } from 'antd';
import AddIcon from '@material-ui/icons/Add';

const StyledPopoverCloseButton = styled(PopoverCloseButton)`
  width: max-content;
  background: #11c4aa;
  color: #efefef;
  border: none;
  border-radius: 4px;
`;

const StyledPopoverContent = styled(PopoverContent)`
  background: rgb(22 12 34);
  padding: 10px;
  border-radius: 6px;
`;
const StyledGift = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 500;
  .detail {
    color: #ffab00;
    font-size: 16px;
    vertical-align: middle;
    line-height: 11px;
  }
`;

const PackageData = Object.values(PACKAGE_DATA).reduce((pre, cur) => pre.concat(cur));

const TDItem = styled.td`
  border-bottom: 2px solid var(--card-color) !important;
  padding: 4px 10px;
`;

const StyledTd = styled.td`
  border-bottom: 2px solid var(--card-color) !important;
  padding: 4px 10px;
`;

const StyledBoxGift = styled.div`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    color: #ffab00;
  }
  .rate-display {
    color: #10c6ac;
  }
`;

export default function MyLockedItem({ stake, updateStaked, isLoading, setLoading }) {
  const { web3, walletAddress } = useSelector((state) => state);
  const [transactionInfo, setTransactionInfo] = useState({
    transactionHash: '',
    isOpen: false,
  });
  const stakedAmount = parseBalance(stake.amount);
  const optionName = stake.termOption;
  const endDate = formatDateYYYYMMDDHHMM(dayjs.unix(parseFloat(stake.releaseDate)).toDate());
  const stakeDate = formatDateYYYYMMDDHHMM(
    dayjs.unix(parseFloat(stake.releaseDate) - parseInt(optionName) * 24 * 3600).toDate()
  );

  const isClaim = dayjs(new Date()).unix() >= parseFloat(stake.releaseDate);

  const rewardDebt = parseBalance(stake.rewardDebt);
  // const accrueDays = dayjs(new Date()).diff(stakeDate, 'days');

  const foundPackageId = findPackageByAmount(stakedAmount, stake.contractFarm);
  const foundPackage = PackageData.find((pack) => pack.id === foundPackageId);
  if (!foundPackage) {
    return (
      <tr style={{ textAlign: 'center', height: '50px' }}>
        <td colSpan='7'>{`No package found with ${stakedAmount} WANA - Contract: ${stake.contractFarm}`}</td>
      </tr>
    );
  }

  const foundOption = foundPackage.options.find(
    (option) => option.duration === parseInt(optionName)
  );
  const handleClaim = async () => {
    setLoading(true);
    try {
      const stakingContract = new web3.eth.Contract(foundPackage.abi, foundPackage.contractFarm);
      await stakingContract.methods
        .unStake(stake.indexStake)
        .send({ from: walletAddress })
        .on('receipt', async (receipt) => {
          if (receipt.status) {
            setTransactionInfo({
              transactionHash: receipt?.transactionHash,
              isOpen: true,
            });
            notification('Withdraw amount stake successfully.', 'success');
            updateStaked(stake.indexStake);
          } else {
            if (receipt?.transactionHash) {
              setTransactionInfo({
                transactionHash: receipt?.transactionHash,
                isOpen: true,
              });
            }
            notification('Withdraw amount stake fail.', 'error');
          }

          setLoading(false);
        })
        .on('error', function (error, receipt) {
          if (receipt?.transactionHash) {
            setTransactionInfo({
              transactionHash: receipt?.transactionHash,
              isOpen: true,
            });
          }
          notification('Withdraw amount stake fail.', 'error');
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const shortTransactionHash = (hash) => {
    return hash ? `${hash?.substr(0, 6)}...${hash?.substr(hash.length - 6, hash.length - 1)}` : '';
  };

  const closeHashPopover = () => {
    setTransactionInfo({
      transactionHash: '',
      isOpen: false,
    });
  };
  const titleByGiftDetail = (giftDetail) => {
    switch (giftDetail) {
      case '*': {
        return 'The snapshot will be taken at the end of every month to do lucky draw, from July until December, 2022';
      }
      case '**': {
        return 'The snapshot will be taken at December 31st, 2022';
      }
      case '***': {
        return 'Granted to the Wallet at the end of staking contract';
      }
      default: {
        return '';
      }
    }
  };
  return (
    <tr>
      <StyledTd>
        <Flex alignItems='center'>
          <Box fontSize='16px' fontWeight='600' textTransform='uppercase' ml='10px'>
            {foundPackage.name}
          </Box>
        </Flex>
      </StyledTd>
      <TDItem>
        <Box fontSize='16px' textAlign='center'>
          {numberFormat(stakedAmount)} WANA
        </Box>
      </TDItem>
      <TDItem>
        <StyledBoxGift>
          <div className='rate-display'>{bnum(stake?.apr).div(100).toFixed()} %</div>
          {foundOption.gift && (
            <>
              <AddIcon margin='0 10px' height='12px' />
              <StyledGift>
                {foundOption.gift}
                <Tooltip title={titleByGiftDetail(foundOption.giftDetail)}>
                  (<span className='detail'>{foundOption.giftDetail}</span>)
                </Tooltip>
              </StyledGift>
            </>
          )}
        </StyledBoxGift>
      </TDItem>
      <TDItem>
        <Box fontSize='16px' textAlign='center'>
          <Box>{stakeDate}</Box>
        </Box>
      </TDItem>
      <TDItem>
        <Box fontSize='16px' textAlign='center'>
          <Box>{`${optionName} days`}</Box>
        </Box>
      </TDItem>
      <TDItem>
        <Box fontSize='16px' textAlign='center'>
          <Box>{endDate}</Box>
        </Box>
      </TDItem>
      {/* <TDItem>
        <Box fontSize='16px' textAlign='center'>
          <Box>{accrueDays} days</Box>
        </Box>
      </TDItem> */}
      <TDItem>
        <Box color='#ffab00' fontSize='16px' fontWeight='600' textAlign='center'>
          <Box>{numberFormat(rewardDebt)} WANA</Box>
        </Box>
      </TDItem>
      <TDItem>
        <Popover
          returnFocusOnClose={false}
          isOpen={transactionInfo.isOpen}
          onClose={closeHashPopover}
          placement='right'
          closeOnBlur={false}
        >
          <PopoverTrigger>
            <Button
              fontWeight='700'
              disabled={!isClaim || isLoading || stake.isStaked}
              onClick={handleClaim}
              type='primary'
              className='btn-stake'
              loading={isLoading}
              style={{ width: 'max-content' }}
            >
              Claim
            </Button>
          </PopoverTrigger>

          <StyledPopoverContent>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <PopoverHeader fontWeight='semibold'>Information</PopoverHeader>
              <StyledPopoverCloseButton />
            </div>
            <PopoverBody>
              <Link
                href={`${AppConstants.BSC_SCAN_HASH_URL}${transactionInfo.transactionHash}`}
                isExternal
              >
                View transaction on BSCScan:{' '}
                {`${shortTransactionHash(transactionInfo.transactionHash)}`}
              </Link>
            </PopoverBody>
          </StyledPopoverContent>
        </Popover>
      </TDItem>
    </tr>
  );
}
